// extracted by mini-css-extract-plugin
module.exports = {"loader":"LayoutSingleColumn_loader__PAW52","root":"LayoutSingleColumn_root__3cKhi","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__1wf6G"};